
export enum OperationMode {
  ORDER_PAD = 1,
  TABLE = 2,
  CASHLESS = 3,
  TICKET
}
